import React, { useEffect } from "react";
import { autoLoad } from "./services/ai/engine";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import PublicLayout from "./components/layout/PublicLayout";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Forgot from "./pages/auth/Forgot";
import Terms from "./pages/auth/Terms";
import { ShellRoute, shellRoutes } from "./routes";

const renderRoutes = (list) =>
  list.map((r, i) => (
    <Route key={r.path || `i${i}`} index={r.index} path={r.path} element={r.element}>
      {r.children ? renderRoutes(r.children) : null}
    </Route>
  ));

// หน้า login/register/forgot: ถ้าล็อกอินแล้วเด้งเข้าแอป
function GuestOnly({ children }) {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Navigate to="/" replace /> : children;
}

export default function App() {
  // เข้าเว็บหน้าไหนก็ได้ -> ถ้ายังไม่มีโมเดล AI ให้เริ่มโหลดเบื้องหลังเลย (รอหน้าแรก render เสร็จก่อน ไม่แย่งโหลดหน้าเว็บ)
  useEffect(() => {
    const start = () => autoLoad();
    const id = window.requestIdleCallback ? window.requestIdleCallback(start, { timeout: 3000 }) : setTimeout(start, 1500);
    return () => (window.cancelIdleCallback && window.requestIdleCallback ? window.cancelIdleCallback(id) : clearTimeout(id));
  }, []);

  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
              <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />
              <Route path="/forgot" element={<GuestOnly><Forgot /></GuestOnly>} />
              <Route path="/terms" element={<Terms />} />
            </Route>
            <Route path="/" element={<ShellRoute />}>{renderRoutes(shellRoutes)}</Route>
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
